import _extends from "@babel/runtime/helpers/esm/extends";
import { internalDateLocale } from "../../../../../lib/date/localeSets";
import { LangCodes } from "../../../../../lib/locale";
import { componentsLocales as CalendarLocales } from "../../../../Calendar/locale/locales/en";
import { componentsLocales as DateSelectLocales } from "../../../../../internal/DateSelect/locale/locales/en";
export var componentsLocales = _extends({
  today: 'Today',
  todayAriaLabel: "Go to today's date"
}, CalendarLocales, DateSelectLocales, internalDateLocale[LangCodes.en_GB]);